import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaYoutube, FaTelegramPlane, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaChevronRight } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f172a] text-slate-300 pt-20 pb-10 px-6 font-sans relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl -ml-48 -mb-48"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Logo & About */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3 group">
              <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center text-white text-2xl font-black shadow-lg group-hover:rotate-6 transition-transform">K</div>
              <div className="flex flex-col">
                <span className="text-white font-black text-xl tracking-tighter leading-none">KASUN</span>
                <span className="text-orange-500 font-black text-xl tracking-tighter leading-none">WALAKUMBURA</span>
              </div>
            </Link>
            <p className="text-slate-400 font-medium leading-relaxed font-sinhala text-sm">
              ජයග්‍රහණය සඳහා බලපාන්නේ වාසනාවට වඩා උත්සාහයයි. ගුණාත්මක අධ්‍යාපනයක් තුළින් දරුවන්ගේ අනාගතය සවිබල ගැන්වීම අපගේ අරමුණයි.
            </p>
            <div className="flex gap-3">
              <SocialIcon icon={<FaFacebookF />} href="#" color="bg-[#3b5998]" />
              <SocialIcon icon={<FaYoutube />} href="#" color="bg-[#ff0000]" />
              <SocialIcon icon={<FaTelegramPlane />} href="#" color="bg-[#0088cc]" />
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white font-black text-xs tracking-[0.2em] uppercase mb-8 flex items-center gap-2">
              <span className="w-6 h-[2px] bg-orange-500"></span>
              Quick Links
            </h4>
            <ul className="space-y-4">
              <FooterLink to="/" label="Home" />
              <FooterLink to="/courses" label="All Courses" />
              <FooterLink to="/faq" label="Help & FAQ" />
              <FooterLink to="/feedback" label="Student Feedback" />
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-black text-xs tracking-[0.2em] uppercase mb-8 flex items-center gap-2">
              <span className="w-6 h-[2px] bg-orange-500"></span>
              Contact Us
            </h4>
            <ul className="space-y-6">
              <ContactItem icon={<FaMapMarkerAlt />} text="No.21/D, Darmasiri Senanayake Street, Warakapola" />
              <ContactItem icon={<FaPhoneAlt />} text="+94 74 0251 710" />
              <ContactItem icon={<FaEnvelope />} text="info@kasunwalakumbura.com" />
            </ul>
          </div>

          {/* Newsletter / Tag */}
          <div>
            <h4 className="text-white font-black text-xs tracking-[0.2em] uppercase mb-8 flex items-center gap-2">
              <span className="w-6 h-[2px] bg-orange-500"></span>
              Our Mission
            </h4>
            <div className="bg-slate-800/50 p-6 rounded-[2rem] border border-slate-700/50">
              <p className="text-sm italic text-slate-400 mb-4 leading-relaxed">
                "Providing state-of-the-art learning experiences to the next generation of students across Sri Lanka."
              </p>
              <span className="text-[10px] font-black tracking-widest text-orange-500 uppercase">#KASUN_WALAKUMBURA</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-10 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] font-bold tracking-widest text-slate-500 uppercase">
          <p>© {currentYear} KASUN WALAKUMBURA ACADEMY. ALL RIGHTS RESERVED.</p>
          <div className="flex gap-8">
            <Link to="/privacy" className="hover:text-orange-500 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-orange-500 transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

const SocialIcon = ({ icon, href, color }) => (
  <a href={href} className={`${color} w-10 h-10 rounded-xl flex items-center justify-center text-white shadow-lg hover:scale-110 hover:-translate-y-1 transition-all duration-300`}>
    {icon}
  </a>
);

const FooterLink = ({ to, label }) => (
  <li>
    <Link to={to} className="group flex items-center gap-2 hover:text-orange-500 transition-all duration-200">
      <FaChevronRight className="text-[8px] text-orange-500 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all" />
      <span className="font-bold text-xs uppercase tracking-wider">{label}</span>
    </Link>
  </li>
);

const ContactItem = ({ icon, text }) => (
  <li className="flex gap-4 items-start group">
    <div className="w-8 h-8 rounded-lg bg-slate-800 flex items-center justify-center text-orange-500 flex-shrink-0 group-hover:bg-orange-500 group-hover:text-white transition-all duration-300">
      {icon}
    </div>
    <span className="text-sm font-medium leading-relaxed group-hover:text-white transition-colors">{text}</span>
  </li>
);

export default Footer;
